module.exports = __webpack_public_path__ + "static/media/subaru-ezi.eda05819.jpg";